import { render, staticRenderFns } from "./newMarketing.vue?vue&type=template&id=291f5f88&scoped=true"
import script from "./newMarketing.vue?vue&type=script&lang=js"
export * from "./newMarketing.vue?vue&type=script&lang=js"
import style0 from "./newMarketing.vue?vue&type=style&index=0&id=291f5f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f5f88",
  null
  
)

export default component.exports